import {
    FETCH_DATA_COMMONS_CAPACITIES_REQUEST,
    FETCH_DATA_COMMONS_CAPACITIES_SUCCESS,
    FETCH_DATA_COMMONS_CAPACITIES_FAILURE,
} from '../../actions/commonsCapacities/get-commonsCapacities-actions';

const initialState = {
    list: [],
    isLoading: false,
    error: null,
    meta: null
};

const CommonsCapacitiesReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_DATA_COMMONS_CAPACITIES_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case FETCH_DATA_COMMONS_CAPACITIES_SUCCESS:
            return {
                ...state,
                isLoading: false,
                list: action.payload.values,
                meta: action.payload.meta
            };
        case FETCH_DATA_COMMONS_CAPACITIES_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default CommonsCapacitiesReducer;